export default "__VITE_PUBLIC_ASSET__608aeb33__"